export default __webpack_public_path__ + "static/media/ico_link_avatar.92cb23c4.svg";